import { Component, OnInit } from '@angular/core';
import { AwsService } from 'src/app/services/service.index';
import swal2 from 'sweetalert2';

@Component({
  selector: 'app-lista-financieras',
  templateUrl: './lista-financieras.component.html',
  styles: []
})
export class ListaFinancierasComponent implements OnInit {
  financieras: any[] = [];
  cols: any[];

  constructor(private awsService: AwsService) {}

  ngOnInit(): void {
    this.awsService.getFinancialCompanies().subscribe(resp => {
      this.financieras = resp.map(item => ({
        ...item,
        bank: item.contributor?.bank || '',
        clabe: item.contributor?.clabe || '',
      }));
    });
    this.cols = [
      { field: 'business_name', header: 'Razón Social' },
      { field: 'bank', header: 'Banco' },
      { field: 'clabe', header: 'CLABE' },
    ];
  }
}
